import React from 'react';
import PrimaryButton from '../shared/PrimaryButton';
import SecondaryButton from '../shared/SecondaryButton';
import {
  CTA_MICROCOPY,
  PHONE_NUMBER,
  PHONE_NUMBER_LINK,
  PRIMARY_CTA_TEXT,
  SECONDARY_CTA_TEXT,
} from '../../data/contact';

const ConversionCTA = ({
  eyebrow,
  title,
  body,
  className = '',
  microcopy = CTA_MICROCOPY,
}) => (
  <section className={`section conversion-cta-section ${className}`.trim()}>
    <div className="container">
      <div className="conversion-cta card">
        <div className="conversion-cta-copy">
          {eyebrow ? <p className="section-eyebrow">{eyebrow}</p> : null}
          <h2>{title}</h2>
          <p>{body}</p>
          {microcopy?.length ? (
            <ul className="conversion-cta-microcopy" aria-label="Why homeowners choose Preferred Service">
              {microcopy.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          ) : null}
        </div>
        <div className="conversion-cta-actions" aria-label="Contact Preferred Service">
          <PrimaryButton to="/contact">{PRIMARY_CTA_TEXT}</PrimaryButton>
          <SecondaryButton href={PHONE_NUMBER_LINK} aria-label={`Call Now at ${PHONE_NUMBER}`}>
            {SECONDARY_CTA_TEXT}
          </SecondaryButton>
        </div>
      </div>
    </div>
  </section>
);

export default ConversionCTA;
